import React, { useState } from 'react';
import { BsPencilSquare, BsCalendarEvent, BsX, BsArrowUp, BsArrowDown, BsCheckCircle } from 'react-icons/bs';
import styles from '../../HedefFormu.module.css';

const EtkinliklerCard = ({ data, onEdit }) => {
  const [showEditModal, setShowEditModal] = useState(false);

  const TARGET = {
    ulusalKongre: 2,
    uluslararasiKongre: 2,
    ulusalSempozyum: 2,
    uluslararasiSempozyum: 2,
    ulusalCalistay: 1,
    uluslararasiCalistay: 1,
    ulusalPanel: 1,
    uluslararasiPanel: 1
  };

  const completionStatus = {
    ulusalKongre: data.ulusalKongre >= TARGET.ulusalKongre,
    uluslararasiKongre: data.uluslararasiKongre >= TARGET.uluslararasiKongre,
    ulusalSempozyum: data.ulusalSempozyum >= TARGET.ulusalSempozyum,
    uluslararasiSempozyum: data.uluslararasiSempozyum >= TARGET.uluslararasiSempozyum,
    ulusalCalistay: data.ulusalCalistay >= TARGET.ulusalCalistay,
    uluslararasiCalistay: data.uluslararasiCalistay >= TARGET.uluslararasiCalistay,
    ulusalPanel: data.ulusalPanel >= TARGET.ulusalPanel,
    uluslararasiPanel: data.uluslararasiPanel >= TARGET.uluslararasiPanel
  };

  const totalKongre = data.ulusalKongre + data.uluslararasiKongre;
  const targetKongre = TARGET.ulusalKongre + TARGET.uluslararasiKongre;

  const totalSempozyum = data.ulusalSempozyum + data.uluslararasiSempozyum;
  const targetSempozyum = TARGET.ulusalSempozyum + TARGET.uluslararasiSempozyum;

  const totalCalistay = data.ulusalCalistay + data.uluslararasiCalistay;
  const targetCalistay = TARGET.ulusalCalistay + TARGET.uluslararasiCalistay;

  const totalPanel = data.ulusalPanel + data.uluslararasiPanel;
  const targetPanel = TARGET.ulusalPanel + TARGET.uluslararasiPanel;

  const totalEvents = totalKongre + totalSempozyum + totalCalistay + totalPanel;
  const targetTotal = targetKongre + targetSempozyum + targetCalistay + targetPanel;

  const handleEdit = () => {
    setShowEditModal(true);
  };

  return (
    <div className={styles.card} data-type="etkinlikler">
      <div className={styles.cardHeader}>
        <h3 className={styles.cardTitle}>
          <BsCalendarEvent className={styles.cardIcon} />
          Etkinlikler
        </h3>
        <div className={styles.cardActions}>
          <button 
            className={styles.actionButton}
            onClick={handleEdit}
            aria-label="Etkinlikleri düzenle"
          >
            <BsPencilSquare />
          </button>
        </div>
      </div>

      <div>
        <div className={styles.formSection}>
          <h4 className={styles.formTitle}>Kongre Katılımı</h4>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              Ulusal Kongre
              {completionStatus.ulusalKongre && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.ulusalKongre})</span>
            </span>
            <div className={styles.statValue}>{data.ulusalKongre}</div>
          </div>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              Uluslararası Kongre
              {completionStatus.uluslararasiKongre && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.uluslararasiKongre})</span>
            </span>
            <div className={styles.statValue}>{data.uluslararasiKongre}</div>
          </div>
          <div className={styles.targetStatus}>
            <div className={styles.targetItem}>
              <span>Toplam:</span>
              <span className={totalKongre >= targetKongre ? styles.targetComplete : styles.targetIncomplete}>
                {totalKongre} / {targetKongre}
              </span>
            </div>
          </div>
        </div>

        <div className={styles.formSection}>
          <h4 className={styles.formTitle}>Sempozyum Katılımı</h4>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              Ulusal Sempozyum
              {completionStatus.ulusalSempozyum && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.ulusalSempozyum})</span>
            </span>
            <div className={styles.statValue}>{data.ulusalSempozyum}</div>
          </div>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              Uluslararası Sempozyum
              {completionStatus.uluslararasiSempozyum && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.uluslararasiSempozyum})</span>
            </span>
            <div className={styles.statValue}>{data.uluslararasiSempozyum}</div>
          </div>
          <div className={styles.targetStatus}>
            <div className={styles.targetItem}>
              <span>Toplam:</span>
              <span className={totalSempozyum >= targetSempozyum ? styles.targetComplete : styles.targetIncomplete}>
                {totalSempozyum} / {targetSempozyum}
              </span>
            </div>
          </div>
        </div>

        <div className={styles.formSection}>
          <h4 className={styles.formTitle}>Çalıştay ve Panel Katılımı</h4>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              Ulusal Çalıştay
              {completionStatus.ulusalCalistay && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.ulusalCalistay})</span>
            </span>
            <div className={styles.statValue}>{data.ulusalCalistay}</div>
          </div>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              Uluslararası Çalıştay
              {completionStatus.uluslararasiCalistay && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.uluslararasiCalistay})</span>
            </span>
            <div className={styles.statValue}>{data.uluslararasiCalistay}</div>
          </div>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              Ulusal Panel
              {completionStatus.ulusalPanel && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.ulusalPanel})</span>
            </span>
            <div className={styles.statValue}>{data.ulusalPanel}</div>
          </div>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              Uluslararası Panel
              {completionStatus.uluslararasiPanel && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.uluslararasiPanel})</span>
            </span>
            <div className={styles.statValue}>{data.uluslararasiPanel}</div>
          </div>
          <div className={styles.targetStatus}>
            <div className={styles.targetItem}>
              <span>Toplam Çalıştay:</span>
              <span className={totalCalistay >= targetCalistay ? styles.targetComplete : styles.targetIncomplete}>
                {totalCalistay} / {targetCalistay}
              </span>
            </div>
            <div className={styles.targetItem} style={{ marginTop: '8px' }}>
              <span>Toplam Panel:</span>
              <span className={totalPanel >= targetPanel ? styles.targetComplete : styles.targetIncomplete}>
                {totalPanel} / {targetPanel}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.totalSection}>
        <div className={styles.totalRow}>
          <span>Toplam Kongre</span>
          <div>{totalKongre} / {targetKongre}</div>
        </div>
        <div className={styles.totalRow}>
          <span>Toplam Sempozyum</span>
          <div>{totalSempozyum} / {targetSempozyum}</div>
        </div>
        <div className={styles.totalRow}>
          <span>Toplam Çalıştay</span>
          <div>{totalCalistay} / {targetCalistay}</div>
        </div>
        <div className={styles.totalRow}>
          <span>Toplam Panel</span>
          <div>{totalPanel} / {targetPanel}</div>
        </div>
        <div className={styles.totalRow} style={{ marginTop: '12px', fontWeight: 'bold' }}>
          <span>Toplam Etkinlik</span>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            {totalEvents} / {targetTotal}
            <span className={totalEvents >= targetTotal ? styles.trendUp : styles.trendDown}>
              {totalEvents >= targetTotal ? <BsArrowUp /> : <BsArrowDown />}
              {Math.abs(targetTotal - totalEvents)}
            </span>
          </div>
        </div>

        <div className={styles.progressBar}>
          <div 
            className={styles.progressFill} 
            style={{ width: `${(totalEvents / targetTotal) * 100}%` }} 
          />
          <span className={styles.progressLabel}>
            {`${((totalEvents / targetTotal) * 100).toFixed(1)}% (Hedef: ${targetTotal})`}
          </span>
        </div>
      </div>

      {showEditModal && (
        <div className={styles.modalOverlay}>
          <div className={styles.modal} data-type="etkinlikler">
            <div className={styles.modalHeader}>
              <h2 className={styles.modalTitle}>
                <BsCalendarEvent /> Etkinlik Hedeflerini Düzenle
              </h2>
              <button 
                className={styles.actionButton}
                onClick={() => setShowEditModal(false)}
                aria-label="Kapat"
              >
                <BsX size={24} />
              </button>
            </div>
            
            <form className={styles.modalForm}>
              <div className={styles.formSection}>
                <h3 className={styles.formTitle}>Kongre Katılımı</h3>
                <p className={styles.detailsLabel}>
                  2025 yılı içerisinde katılım sağlanması planlanan kongrelerin sayısını belirtiniz.
                </p>
                <div className={styles.formRow}>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>Uluslararası Kongre (Hedef: {TARGET.uluslararasiKongre})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.uluslararasiKongre}
                      min="0"
                    />
                  </div>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>Ulusal Kongre (Hedef: {TARGET.ulusalKongre})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.ulusalKongre}
                      min="0"
                    />
                  </div>
                </div>
              </div>

              <div className={styles.formSection}>
                <h3 className={styles.formTitle}>Sempozyum Katılımı</h3>
                <p className={styles.detailsLabel}>
                  2025 yılı içerisinde katılım sağlanması planlanan sempozyumların sayısını belirtiniz.
                </p>
                <div className={styles.formRow}>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>Uluslararası Sempozyum (Hedef: {TARGET.uluslararasiSempozyum})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.uluslararasiSempozyum}
                      min="0"
                    />
                  </div>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>Ulusal Sempozyum (Hedef: {TARGET.ulusalSempozyum})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.ulusalSempozyum}
                      min="0"
                    />
                  </div>
                </div>
              </div>

              <div className={styles.formSection}>
                <h3 className={styles.formTitle}>Çalıştay ve Panel Katılımı</h3>
                <p className={styles.detailsLabel}>
                  2025 yılı içerisinde katılım sağlanması planlanan çalıştay ve panellerin sayısını belirtiniz.
                </p>
                <div className={styles.formRow}>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>Uluslararası Çalıştay (Hedef: {TARGET.uluslararasiCalistay})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.uluslararasiCalistay}
                      min="0"
                    />
                  </div>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>Ulusal Çalıştay (Hedef: {TARGET.ulusalCalistay})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.ulusalCalistay}
                      min="0"
                    />
                  </div>
                </div>
                <div className={styles.formRow}>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>Uluslararası Panel (Hedef: {TARGET.uluslararasiPanel})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.uluslararasiPanel}
                      min="0"
                    />
                  </div>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>Ulusal Panel (Hedef: {TARGET.ulusalPanel})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.ulusalPanel}
                      min="0"
                    />
                  </div>
                </div>
              </div>
            </form>

            <div className={styles.buttonContainer}>
              <button 
                className={styles.cancelButton}
                onClick={() => setShowEditModal(false)}
              >
                İptal
              </button>
              <button className={styles.saveButton}>
                Kaydet
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EtkinliklerCard; 